/**
 * 1. 提供各个 Layer 样式属性初始值的注册服务
 * 2. 当 Layer 通过 style() 改变某些样式属性时，需要感知并标记该属性已经失效，
 *    随后当 Layer 重绘时通过 dirty 标记进行脏检查。重新传入 uniform 或者构建顶点数据（更新 Buffer 中的指定位置）。
 * @see https://yuque.antfin-inc.com/yuqi.pyq/fgetpa/qfuzg8
 */

export let ScaleTypes = /*#__PURE__*/function (ScaleTypes) {
  ScaleTypes["LINEAR"] = "linear";
  ScaleTypes["SEQUENTIAL"] = "sequential";
  ScaleTypes["POWER"] = "power";
  ScaleTypes["LOG"] = "log";
  ScaleTypes["IDENTITY"] = "identity";
  ScaleTypes["TIME"] = "time";
  ScaleTypes["QUANTILE"] = "quantile";
  ScaleTypes["QUANTIZE"] = "quantize";
  ScaleTypes["THRESHOLD"] = "threshold";
  ScaleTypes["CAT"] = "cat";
  ScaleTypes["DIVERGING"] = "diverging";
  ScaleTypes["CUSTOM"] = "threshold";
  return ScaleTypes;
}({});
export let StyleScaleType = /*#__PURE__*/function (StyleScaleType) {
  StyleScaleType["CONSTANT"] = "constant";
  StyleScaleType["VARIABLE"] = "variable";
  return StyleScaleType;
}({});
export let AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType[AttributeType["Attribute"] = 0] = "Attribute";
  AttributeType[AttributeType["InstancedAttribute"] = 1] = "InstancedAttribute";
  AttributeType[AttributeType["Uniform"] = 2] = "Uniform";
  return AttributeType;
}({});